import { addDays, addMonths, addWeeks, addYears, format, parseISO, differenceInDays } from 'date-fns';
import { formatInTimeZone, toZonedTime } from 'date-fns-tz';
import type { RecurringType } from '../types';

const IT_TZ = 'Europe/Rome';

/** Returns today's date string in yyyy-MM-dd, anchored to Italy timezone */
export function todayIT(): string {
  return formatInTimeZone(new Date(), IT_TZ, 'yyyy-MM-dd');
}

/** Returns the next due date string given a base date, type and optional frequency_days */
export function calcNextDue(
  from: string,
  type: RecurringType,
  frequencyDays?: number | null,
): string | null {
  if (type === 'none') return null;
  const base = toZonedTime(parseISO(from), IT_TZ);

  if (frequencyDays && frequencyDays > 0) {
    return format(addDays(base, frequencyDays), 'yyyy-MM-dd');
  }

  switch (type) {
    case 'weekly':  return format(addWeeks(base, 1),  'yyyy-MM-dd');
    case 'monthly': return format(addMonths(base, 1), 'yyyy-MM-dd');
    case 'yearly':  return format(addYears(base, 1),  'yyyy-MM-dd');
    default:        return null;
  }
}

/** Human-readable label for how far the next_due is */
export function nextDueLabel(nextDue: string): string {
  const today = todayIT();
  const diff = differenceInDays(parseISO(nextDue), parseISO(today));
  if (diff < 0)  return `Scaduta ${Math.abs(diff)}g fa`;
  if (diff === 0) return 'Scade oggi';
  if (diff === 1) return 'Domani';
  if (diff <= 7)  return `Tra ${diff} giorni`;
  if (diff <= 30) return `Tra ${diff} giorni`;
  return format(parseISO(nextDue), 'd MMM yyyy');
}

/** Urgency level for colour coding */
export function nextDueUrgency(nextDue: string): 'overdue' | 'today' | 'soon' | 'upcoming' {
  const today = todayIT();
  const diff = differenceInDays(parseISO(nextDue), parseISO(today));
  if (diff < 0)  return 'overdue';
  if (diff === 0) return 'today';
  if (diff <= 7)  return 'soon';
  return 'upcoming';
}
